import { ActionType } from '../enums';

/**
 * Фабрика для билдеров имен экшенов
 */
export const createActionNameBuilder =
  <T extends ActionType>(type: T) =>
  <U extends string = string>(domainPrefix: U) =>
  <Z extends string = string>(actionName: Z): `${T}/${U}/${Z}` =>
    `${type}/${domainPrefix}/${actionName}`;
